import type { UserRole } from '@utazzo/shared';

/**
 * Post-login landing for every role: the Welcome Utazzer page. It has no
 * permission gate, so it can never bounce into a loop. Drives the `/` route
 * (HomeRoute), the logo "home" link, and the RequireRole bounce fallback.
 */
export const WELCOME_PATH = '/welcome';

/**
 * The Marketing Reports ("Marketing dashboard") route. Marketing-only users
 * (the `marketing_in` role) land here instead of Welcome and skip the welcome
 * gate entirely - it is the only screen their permissions expose anyway.
 */
export const MARKETING_DASHBOARD_PATH = '/reports/marketing';

/** Role code (Roles master) that lands on the Marketing dashboard, not Welcome. */
export const MARKETING_IN_ROLE_CODE = 'marketing_in';

/** True when the signed-in user carries the marketing-only custom role. */
export const isMarketingDashboardRole = (
  assignedRoleCodes: readonly string[] | null | undefined,
): boolean => !!assignedRoleCodes && assignedRoleCodes.includes(MARKETING_IN_ROLE_CODE);

/**
 * Home path by role. Every role now lands on the Welcome page - one, shared
 * default view (the old role-specific landings caused confusion between the
 * dashboard, reports and lead inbox). `role` is kept in the signature for
 * callers but no longer changes the destination.
 */
export const homePathForRole = (_role: UserRole | null | undefined): string => WELCOME_PATH;
